import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../pagination.js';

import { CustomerVehicleResponseSchema } from './customer-vehicle.schemas.js';
import { MaintenanceDueStatusSchema } from './maintenance.schemas.js';

export const VehicleListSortFieldSchema = z.enum([
  'plate',
  'customer',
  'model',
  'linkStatus',
  'maintenance',
]);
export type VehicleListSortField = z.infer<typeof VehicleListSortFieldSchema>;

export const ListVehiclesQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(1).max(100).optional(),
  ),
  sort: VehicleListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export type ListVehiclesQuery = z.infer<typeof ListVehiclesQuerySchema>;

export const VehicleListItemResponseSchema = CustomerVehicleResponseSchema.extend({
  partyDisplayName: z.string(),
  maintenanceStatus: MaintenanceDueStatusSchema.nullable(),
});

export type VehicleListItemResponse = z.infer<typeof VehicleListItemResponseSchema>;

export const ListVehiclesResponseSchema = z.object({
  items: z.array(VehicleListItemResponseSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListVehiclesResponse = z.infer<typeof ListVehiclesResponseSchema>;
